import { ReactElement } from 'react';
import { ContactLink, ContactLinks, Wrapper } from './Contact.elements';
import portrait from '../../avatar.png';
import { IoLogoGithub, IoLogoLinkedin } from 'react-icons/io5';

export const Contact = (): ReactElement => {
  return (
    <Wrapper>
      <img src={portrait} alt={'portrait of a software engineer'} />
      <ContactLinks>
        <ContactLink>
          <IoLogoLinkedin />{' '}
          <a href={'https://au.linkedin.com/in/chris-davis-b56213b9'}>
            LinkedIn
          </a>
        </ContactLink>
        <ContactLink>
          <IoLogoGithub />{' '}
          <a href={'https://github.com/chrisdavis511'}>Github</a>
        </ContactLink>
      </ContactLinks>
    </Wrapper>
  );
};
